'use client';

import * as React from 'react';

import { APP_NAME } from '@workspace/common/app';
import { cn } from '@workspace/ui/lib/utils';

export type LogoElement = React.ComponentRef<'div'>;
export type LogoProps = React.ComponentPropsWithoutRef<'div'> & {
  hideSymbol?: boolean;
  hideWordmark?: boolean;
};
export function Logo({
  hideSymbol,
  hideWordmark,
  className,
  ...other
}: LogoProps): React.JSX.Element {
  return (
    <div
      className={cn('flex items-center space-x-2', className)}
      {...other}
    >
      {!hideSymbol && (
        <div className="flex size-9 items-center justify-center p-1">
          <div className="text-primary-foreground bg-primary flex size-7 items-center justify-center rounded-md border">
            <svg
              width="1024"
              height="1024"
              viewBox="0 0 1024 1024"
              preserveAspectRatio="xMidYMid meet"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g
                transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
                fill="#000000"
                stroke="none"
              >
                <path d="M4575 6929 c-850 -38 -1049 -98 -1373 -413 -195 -190 -347 -371 -482 -574 l-55 -83 -40 6 c-22 3 -92 8 -155 12 -151 8 -251 -11 -378 -72 -201 -96 -318 -279 -354 -550 -29 -225 -10 -705 47 -1175 27 -222 90 -633 105 -690 6 -22 8 244 6 740 -2 426 0 823 5 883 23 284 123 473 294 558 105 51 164 55 525 30 284 -19 467 -27 1004 -46 94 -3 168 -4 165 -1 -15 14 -588 165 -788 206 -73 16 -138 33 -144 39 -26 26 212 330 404 516 223 216 386 286 734 314 677 56 1711 49 2185 -15 296 -40 472 -152 768 -492 83 -95 242 -312 242 -330 0 -5 -30 -15 -67 -21 -153 -26 -833 -198 -850 -215 -11 -11 822 21 1161 46 259 18 321 19 380 9 258 -44 396 -244 425 -616 5 -67 7 -455 4 -875 -3 -415 -3 -753 0 -750 15 14 96 541 121 790 43 411 61 799 46 975 -15 183 -32 267 -69 348 -118 263 -320 390 -616 392 -66 0 -148 -3 -181 -7 l-62 -7 -43 62 c-159 226 -528 625 -694 749 -192 144 -378 200 -770 233 -390 32 -1071 44 -1500 24z" />
                <path d="M2139 5093 c-13 -35 4 -168 31 -249 28 -82 61 -133 119 -187 99 -93 163 -112 824 -242 181 -36 338 -65 348 -65 21 0 19 3 161 -245 50 -88 113 -195 141 -238 40 -63 47 -81 36 -88 -8 -5 -145 -9 -304 -9 -160 0 -305 -4 -323 -9 -29 -9 -156 -96 -482 -330 -164 -118 -193 -141 -176 -141 21 0 434 83 595 120 l133 30 1888 0 1887 0 114 -26 c176 -40 593 -123 597 -119 5 5 -225 175 -443 328 -135 94 -192 129 -228 137 -27 5 -173 10 -337 10 -175 0 -290 4 -290 9 0 6 24 49 54 98 29 48 94 162 144 253 50 91 97 176 105 190 13 24 27 28 168 54 221 40 725 143 815 166 110 28 176 62 238 120 84 79 127 173 146 315 10 81 1 138 -22 143 -33 6 -1271 -363 -1603 -478 -59 -20 -70 -20 -1365 -21 l-1305 0 -120 41 c-462 156 -1465 460 -1519 460 -9 0 -21 -12 -27 -27z m4181 -824 c0 -7 -59 -121 -131 -255 l-131 -244 -938 0 -938 0 -37 73 c-21 39 -80 150 -131 244 -52 95 -94 177 -94 183 0 7 393 10 1200 10 888 0 1200 -3 1200 -11z" />
              </g>
            </svg>
            {/* <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  d="M7.81815 8.36373L12 0L24 24H15.2809L7.81815 8.36373Z"
                  fill="currentColor"
                />
                <path
                  d="M4.32142 15.3572L8.44635 24H-1.14809e-06L4.32142 15.3572Z"
                  fill="currentColor"
                />
              </g>
            </svg> */}
          </div>
        </div>
      )}
      {!hideWordmark && <span className="font-bold">{APP_NAME}</span>}
    </div>
  );
}
